export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any }
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: any; output: any }
}

export type _Service = {
  __typename?: '_Service'
  sdl?: Maybe<Scalars['String']['output']>
}

export type AnalyticsDayType = {
  __typename?: 'AnalyticsDayType'
  day: Scalars['Date']['output']
  scans: Scalars['Int']['output']
  users: Scalars['Int']['output']
}

export type AnalyticsTotalType = {
  __typename?: 'AnalyticsTotalType'
  avgScans: Scalars['Float']['output']
  avgUsers: Scalars['Float']['output']
  scans: Scalars['Int']['output']
  scansToday: Scalars['Int']['output']
  users: Scalars['Int']['output']
}

export type AnalyticsType = {
  __typename?: 'AnalyticsType'
  days?: Maybe<Array<Maybe<AnalyticsDayType>>>
  lastScanDate?: Maybe<Scalars['Date']['output']>
  total?: Maybe<AnalyticsTotalType>
}

export type AnalyticsTypeDaysArgs = {
  endDay?: InputMaybe<Scalars['Date']['input']>
  numDays?: InputMaybe<Scalars['Int']['input']>
}

export type ApiClientCampaignType = Node & {
  __typename?: 'ApiClientCampaignType'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  lastModified: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  numFlowcodes?: Maybe<Scalars['Int']['output']>
  timeStamp: Scalars['DateTime']['output']
}

export type ApiClientCampaignTypeConnection = {
  __typename?: 'ApiClientCampaignTypeConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApiClientCampaignTypeEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
}

/** A Relay edge containing a `ApiClientCampaignType` and its cursor. */
export type ApiClientCampaignTypeEdge = {
  __typename?: 'ApiClientCampaignTypeEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<ApiClientCampaignType>
}

/**
 * ArchiveBatch is called when the user chooses to archive a code.
 * The archive_reason is set to USER_ARCHIVAL accordingly.
 */
export type ArchiveBatch = {
  __typename?: 'ArchiveBatch'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** An enumeration. */
export enum AssetFileAssetType {
  /** Center Image */
  CenterImage = 'CENTER_IMAGE',
  /** Container */
  Container = 'CONTAINER',
  /** External Center Image */
  ExternalCenterImage = 'EXTERNAL_CENTER_IMAGE',
  /** Eyes */
  Eyes = 'EYES',
  /** File */
  File = 'FILE',
  /** Gif */
  Gif = 'GIF',
  /** Icon */
  Icon = 'ICON',
  /** Pattern */
  Pattern = 'PATTERN',
  /** Print */
  Print = 'PRINT',
  /** Rim */
  Rim = 'RIM'
}

export type AssetFileObjectType = Node & {
  __typename?: 'AssetFileObjectType'
  assetName: Scalars['String']['output']
  assetType: AssetFileAssetType
  batch?: Maybe<BatchDjangoType>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  tags: Array<StudioTagObjectType>
  url?: Maybe<Scalars['String']['output']>
}

export type AssetFileObjectTypeConnection = {
  __typename?: 'AssetFileObjectTypeConnection'
  edgeCount?: Maybe<Scalars['Int']['output']>
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AssetFileObjectTypeEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** A Relay edge containing a `AssetFileObjectType` and its cursor. */
export type AssetFileObjectTypeEdge = {
  __typename?: 'AssetFileObjectTypeEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<AssetFileObjectType>
}

export type AssetLabelType = Node & {
  __typename?: 'AssetLabelType'
  batch?: Maybe<BatchDjangoType>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  isRecommended: Scalars['Boolean']['output']
  name: Scalars['String']['output']
}

export type AssetLabelTypeConnection = {
  __typename?: 'AssetLabelTypeConnection'
  edgeCount?: Maybe<Scalars['Int']['output']>
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AssetLabelTypeEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** A Relay edge containing a `AssetLabelType` and its cursor. */
export type AssetLabelTypeEdge = {
  __typename?: 'AssetLabelTypeEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<AssetLabelType>
}

/**
 * AssignStudioConfig gives a user the ability to use the StudioConfig
 * i.e. used by the FE to give user access to a code design after signing up
 */
export type AssignStudioConfig = {
  __typename?: 'AssignStudioConfig'
  ok?: Maybe<Scalars['Boolean']['output']>
  studioConfig?: Maybe<StudioConfigObjectType>
}

export type AssociateProject = {
  __typename?: 'AssociateProject'
  dhProjectId: Scalars['String']['output']
  ok: Scalars['Boolean']['output']
  projectId: Scalars['UUID']['output']
}

export type AutoDesignObjectType = {
  __typename?: 'AutoDesignObjectType'
  configuration?: Maybe<Scalars['JSONString']['output']>
  ids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>
}

export type BatchConnection = {
  __typename?: 'BatchConnection'
  edgeCount?: Maybe<Scalars['Int']['output']>
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BatchEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** An enumeration. */
export enum BatchCreationSource {
  /** Api */
  Api = 'API',
  /** Flowtag */
  Flowtag = 'FLOWTAG',
  /** Starter Kit */
  StarterKit = 'STARTER_KIT',
  /** Video Tool */
  VideoTool = 'VIDEO_TOOL'
}

export type BatchDesignTemplateInputType = {
  configuration?: InputMaybe<Scalars['JSONString']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type BatchDesignTemplateObjectType = Node & {
  __typename?: 'BatchDesignTemplateObjectType'
  configuration: Scalars['JSONString']['output']
  /** The ID of the object. */
  id: Scalars['ID']['output']
  lastModified: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  owner: UserType
  timeStamp: Scalars['DateTime']['output']
}

export type BatchDesignTemplateObjectTypeConnection = {
  __typename?: 'BatchDesignTemplateObjectTypeConnection'
  edgeCount?: Maybe<Scalars['Int']['output']>
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BatchDesignTemplateObjectTypeEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** A Relay edge containing a `BatchDesignTemplateObjectType` and its cursor. */
export type BatchDesignTemplateObjectTypeEdge = {
  __typename?: 'BatchDesignTemplateObjectTypeEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<BatchDesignTemplateObjectType>
}

export type BatchDjangoType = Node & {
  __typename?: 'BatchDjangoType'
  activeLink?: Maybe<LinkDjangoType>
  analytics?: Maybe<AnalyticsType>
  archived: Scalars['Boolean']['output']
  assetFile?: Maybe<AssetFileObjectType>
  assetFileName?: Maybe<Scalars['String']['output']>
  assetLabels?: Maybe<Array<Maybe<AssetLabelType>>>
  batchOwner?: Maybe<BatchOwnerDjangoType>
  batchRules?: Maybe<RuleBasedObjectType>
  creationSource?: Maybe<BatchCreationSource>
  directory?: Maybe<DirectoryType>
  domain: Scalars['String']['output']
  entityPermissions?: Maybe<Array<Maybe<EntityPermissionObjectType>>>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  lastModified: Scalars['DateTime']['output']
  nickname: Scalars['String']['output']
  studioConfig?: Maybe<StudioConfigObjectType>
  timeStamp: Scalars['DateTime']['output']
  type: BatchType
}

export type BatchDjangoTypeConnection = {
  __typename?: 'BatchDjangoTypeConnection'
  edgeCount?: Maybe<Scalars['Int']['output']>
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BatchDjangoTypeEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** A Relay edge containing a `BatchDjangoType` and its cursor. */
export type BatchDjangoTypeEdge = {
  __typename?: 'BatchDjangoTypeEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<BatchDjangoType>
}

/** A Relay edge containing a `Batch` and its cursor. */
export type BatchEdge = {
  __typename?: 'BatchEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<BatchDjangoType>
}

export type BatchInputType = {
  nickname?: InputMaybe<Scalars['String']['input']>
  redirectDomain?: InputMaybe<Scalars['String']['input']>
  studioConfigId?: InputMaybe<Scalars['UUID']['input']>
}

export type BatchOwnerDjangoType = {
  __typename?: 'BatchOwnerDjangoType'
  anonymousSessionId?: Maybe<Scalars['String']['output']>
  batch: BatchDjangoType
  isOwner?: Maybe<Scalars['Boolean']['output']>
  user?: Maybe<UserType>
}

/** An enumeration. */
export enum BatchType {
  /** many */
  Many = 'MANY',
  /** one */
  One = 'ONE',
  /** static_code */
  StaticCode = 'STATIC_CODE'
}

export type BorderDesignObjectType = {
  __typename?: 'BorderDesignObjectType'
  partialId?: Maybe<Scalars['UUID']['output']>
  studioConfig?: Maybe<StudioConfigObjectType>
}

export type BrandKit = {
  __typename?: 'BrandKit'
  flowcodeImage: Scalars['String']['output']
  logoImage: Scalars['String']['output']
  primaryColor: Scalars['String']['output']
  primaryText: Scalars['String']['output']
  secondaryColor: Scalars['String']['output']
}

export type BrandKitInput = {
  logoImage?: InputMaybe<Scalars['String']['input']>
  primaryColor?: InputMaybe<Scalars['String']['input']>
  primaryText?: InputMaybe<Scalars['String']['input']>
  secondaryColor?: InputMaybe<Scalars['String']['input']>
}

/**
 * BulkArchiveBatches is called when the user chooses to archive a list of codes.
 * The archive_reason is set to USER_ARCHIVAL accordingly.
 */
export type BulkArchiveBatches = {
  __typename?: 'BulkArchiveBatches'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** BulkDeleteDirectories deletes a list of directories and all the batches within it */
export type BulkDeleteDirectories = {
  __typename?: 'BulkDeleteDirectories'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** BulkRestoreBatches is the reverse of BulkArchiveBatches and restores a list of codes to be active again. */
export type BulkRestoreBatches = {
  __typename?: 'BulkRestoreBatches'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** BulkUpdateBatchDirectory changes or removes the directory a list of batches are in */
export type BulkUpdateBatchDirectory = {
  __typename?: 'BulkUpdateBatchDirectory'
  batches?: Maybe<Array<Maybe<BatchDjangoType>>>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** BulkUpdateDirectories moves a list of directories in and out of other directories */
export type BulkUpdateDirectories = {
  __typename?: 'BulkUpdateDirectories'
  ok?: Maybe<Scalars['Boolean']['output']>
}

export enum CanadiensMode {
  HockeyMode = 'HOCKEY_MODE',
  ShowMode = 'SHOW_MODE'
}

export type Categories = {
  __typename?: 'Categories'
  categories?: Maybe<Array<Category>>
  pageInfo: PageInfo
}

export type Category = {
  __typename?: 'Category'
  categoryId: Scalars['UUID']['output']
  categoryName: Scalars['String']['output']
  sectionName: Scalars['String']['output']
}

export type CodeManagementType = {
  __typename?: 'CodeManagementType'
  allBatches?: Maybe<BatchConnection>
  highlighted?: Maybe<BatchConnection>
}

export type CodeManagementTypeAllBatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type CodeManagementTypeHighlightedArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

/**
 * CollectBatch is used with scan to own codes and creates a BatchOwner for a Batch
 * Switches `is_collectible` to false as scan to own codes are one-time use only.
 *
 * -   CollectBatch will grant the user access to the studio_config design if they do not have it already
 * -   Note: there is no check against ithaca, however that is not a concern since users are net-new.
 *     Worth keeping a pulse on whether or not users of STO have accounts in which the same studio_config could be
 *     assigned to a user
 * -   claimed_page_id is the page_id of the slugName that is getting claimed in the preset onboarding flow. If
 *     we aren't in the preset onboarding flow then claimed_page_id should be None
 */
export type CollectBatch = {
  __typename?: 'CollectBatch'
  batchOwner?: Maybe<BatchOwnerDjangoType>
  claimedPageId?: Maybe<Scalars['ID']['output']>
  ok?: Maybe<Scalars['Boolean']['output']>
}

export type CollectBatchCodeInputType = {
  nickname?: InputMaybe<Scalars['String']['input']>
  redirectType: RedirectType
  redirectValue: Scalars['String']['input']
}

export type CollectibleResponseType = {
  __typename?: 'CollectibleResponseType'
  isCollectible?: Maybe<Scalars['Boolean']['output']>
  redirectType?: Maybe<RedirectType>
  redirectValue?: Maybe<Scalars['String']['output']>
}

export enum CombinedGeneratorCampaigns {
  OptiCombinedGenerator_1 = 'OPTI_COMBINED_GENERATOR_1',
  OptiCombinedGenerator_2 = 'OPTI_COMBINED_GENERATOR_2',
  OptiCombinedGenerator_3 = 'OPTI_COMBINED_GENERATOR_3',
  OptiCombinedGenerator_4 = 'OPTI_COMBINED_GENERATOR_4'
}

/** CreateAssetLabels creates asset labels for the specified batch id. */
export type CreateAssetLabels = {
  __typename?: 'CreateAssetLabels'
  assetLabels?: Maybe<Array<Maybe<AssetLabelType>>>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * CreateBatch creates a batch, link, batch_owner, and redirect object
 * It also creates entries in the batch_partial table if partial ids are supplied
 */
export type CreateBatch = {
  __typename?: 'CreateBatch'
  batch?: Maybe<BatchDjangoType>
  link?: Maybe<LinkDjangoType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * CreateBatchDesignTemplate creates a BatchDesignTemplate object for a user and configuration
 * BatchDesignTemplate's are saved code configurations that allow users to save custom designs they have made for reuse
 */
export type CreateBatchDesignTemplate = {
  __typename?: 'CreateBatchDesignTemplate'
  batchTemplate?: Maybe<BatchDesignTemplateObjectType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * CreateBatchRules takes in a rule and/or an interstitial and merges them into a single config that determines how the batch is handled during a redirect.
 * It updates the CoreBatchRulesHistory table with an entry for each created object.
 */
export type CreateBatchRules = {
  __typename?: 'CreateBatchRules'
  batchRule?: Maybe<RuleBasedObjectType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * CreateCollectibleBatch handles creating collectible flowcodes
 * All flowcodes created through this mutation are attached to our internal api_client_id and campaign
 *
 * - In the case that a batchId is passing in, we want to use that code to build a new code for the user.
 * - This code is not a collectible code but a copy of the one that was passed in
 *
 * - In the case that sendEmail is passed in, we send a notification with the new code for the user.
 */
export type CreateCollectibleBatch = {
  __typename?: 'CreateCollectibleBatch'
  batch?: Maybe<BatchDjangoType>
  link?: Maybe<LinkDjangoType>
}

/**
 * CreateDirectory creates a directory
 * Directories can be nested
 * if batch_ids are supplied the batches are updated to be in the directory
 */
export type CreateDirectory = {
  __typename?: 'CreateDirectory'
  directory?: Maybe<DirectoryType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * CreateExternalDomain creates an external domain for a user/org who owns their domain and
 * brings it into the Flowcode ecosystem, and assigns it to that user/org. For example,
 * if BMW owns the domain https://bmw.com/ and wants to create redirect and/or page urls
 * using this domain, this mutation creates the domain in the Domains Service and assigns
 * the BMW org as the owner of the domain.
 */
export type CreateExternalDomain = {
  __typename?: 'CreateExternalDomain'
  externalDomain?: Maybe<WhiteLabelRedirectDomainType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** CreatePlacementTemplateCategory creates either a child or root (parentless) category */
export type CreatePlacementTemplateCategory = {
  __typename?: 'CreatePlacementTemplateCategory'
  ok?: Maybe<Scalars['Boolean']['output']>
  placementTemplateCategory?: Maybe<PlacementTemplateCategoryObjectType>
}

/** CreatePlacementTemplateConfig creates a placement template config with a placeholder asset file */
export type CreatePlacementTemplateConfig = {
  __typename?: 'CreatePlacementTemplateConfig'
  ok?: Maybe<Scalars['Boolean']['output']>
  placementTemplateConfig?: Maybe<PlacementTemplateConfigObjectType>
}

/** CreatePlacementTemplateDownloadData records data for a placement template download/print event */
export type CreatePlacementTemplateDownloadData = {
  __typename?: 'CreatePlacementTemplateDownloadData'
  ok?: Maybe<Scalars['Boolean']['output']>
}

export type CreateProjectExport = {
  __typename?: 'CreateProjectExport'
  ok: Scalars['Boolean']['output']
  projectExportId: Scalars['UUID']['output']
}

/**
 * CreateRedirectSubdomain creates a subdomain and assigns it to the requesting user,
 * creates entries in the WhiteLabelSubdomain and WhiteLabelSubdomainOwner tables in the domains service,
 * and creates an asset permission entry in ithaca for the user and subdomain.
 */
export type CreateRedirectSubdomain = {
  __typename?: 'CreateRedirectSubdomain'
  ok?: Maybe<Scalars['Boolean']['output']>
  redirectSubdomain?: Maybe<WhiteLabelRedirectDomainType>
}

/**
 * CreateStudioConfig creates a StudioConfig and assigns source
 * Used for code creation and duplication
 * During custom code creation the FE will call this mutation then CreateBatch
 */
export type CreateStudioConfig = {
  __typename?: 'CreateStudioConfig'
  ok?: Maybe<Scalars['Boolean']['output']>
  studioConfig?: Maybe<StudioConfigObjectType>
}

/**
 * Used to differentiate behavior
 *         - null(default): created from the plaform
 *         - flowtag: the batch is used to create a flowtag
 *         - API: the batch was created from the enterprise API
 *
 */
export enum CreationSource {
  Api = 'API',
  Flowtag = 'FLOWTAG',
  StarterKit = 'STARTER_KIT',
  VideoTool = 'VIDEO_TOOL'
}

/** DeleteAssetLabels deletes asset labels for the specified asset label ids. */
export type DeleteAssetLabels = {
  __typename?: 'DeleteAssetLabels'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * DeleteBatchDesignTemplate deletes a BatchDesignTemplate object.
 * To be used from internal admin, and requires super admin access.
 */
export type DeleteBatchDesignTemplate = {
  __typename?: 'DeleteBatchDesignTemplate'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * DeleteBatchRules takes in should_delete_rule and should_delete_interstitial and removes the corresponding objects from the config.
 * If there is no remaining config after deletion, the entry will be deleted from the db.
 * Updates the CoreBatchRulesHistory table with an entry for each deleted object.
 */
export type DeleteBatchRules = {
  __typename?: 'DeleteBatchRules'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** DeleteDirectory deletes a directory and all the batches within it */
export type DeleteDirectory = {
  __typename?: 'DeleteDirectory'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * DeleteExternalDomain soft-deletes an external domain. The operation will fail if the domain
 * has active/verified subdomains associated with it, or if the domain does not exist.
 */
export type DeleteExternalDomain = {
  __typename?: 'DeleteExternalDomain'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** DeletePlacementTemplateCategory deletes a placement template */
export type DeletePlacementTemplateCategory = {
  __typename?: 'DeletePlacementTemplateCategory'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** DeletePlacementTemplateConfig deletes a PlacementTemplateConfig */
export type DeletePlacementTemplateConfig = {
  __typename?: 'DeletePlacementTemplateConfig'
  ok?: Maybe<Scalars['Boolean']['output']>
}

export type DeleteProject = {
  __typename?: 'DeleteProject'
  ok: Scalars['Boolean']['output']
}

/**
 * Given subdomainId, soft deletes the associated subdomain from the domains service db and marks
 * the WhiteLabelRedirectDomain record as inactive, and deletes any shared permissions for the subdomain.
 */
export type DeleteRedirectSubdomain = {
  __typename?: 'DeleteRedirectSubdomain'
  ok?: Maybe<Scalars['Boolean']['output']>
}

export type DirectoryConnection = {
  __typename?: 'DirectoryConnection'
  edgeCount?: Maybe<Scalars['Int']['output']>
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DirectoryEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']['output']>
}

export type DirectoryDetailType = {
  __typename?: 'DirectoryDetailType'
  id?: Maybe<Scalars['Int']['output']>
  isRoot?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
}

/** A Relay edge containing a `Directory` and its cursor. */
export type DirectoryEdge = {
  __typename?: 'DirectoryEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<DirectoryType>
}

export type DirectoryManagementType = {
  __typename?: 'DirectoryManagementType'
  allDirs?: Maybe<DirectoryConnection>
}

export type DirectoryManagementTypeAllDirsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type DirectoryType = Node & {
  __typename?: 'DirectoryType'
  analytics?: Maybe<AnalyticsType>
  ancestors?: Maybe<Array<Maybe<DirectoryType>>>
  batchCount?: Maybe<Scalars['Int']['output']>
  batchDirectorySet: BatchDjangoTypeConnection
  children?: Maybe<Array<Maybe<DirectoryType>>>
  descendantCount?: Maybe<Scalars['Int']['output']>
  descendants?: Maybe<Array<Maybe<DirectoryType>>>
  description?: Maybe<Scalars['String']['output']>
  entityPermissions?: Maybe<Array<Maybe<EntityPermissionObjectType>>>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  isOwner?: Maybe<Scalars['Boolean']['output']>
  level: Scalars['Int']['output']
  name: Scalars['String']['output']
  parent?: Maybe<DirectoryType>
  timeStamp: Scalars['DateTime']['output']
  user?: Maybe<UserType>
}

export type DirectoryTypeBatchDirectorySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  creationSource?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  nickname_Icontains?: InputMaybe<Scalars['String']['input']>
  nickname_Istartswith?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
}

/**
 * EditBatchDesign creates a new StudioConfig and points the batch to it
 * This is used when switching to a non-premade design
 */
export type EditBatchDesign = {
  __typename?: 'EditBatchDesign'
  batch?: Maybe<BatchDjangoType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** EditConfiguration alters the configuration column of a studio config */
export type EditConfiguration = {
  __typename?: 'EditConfiguration'
  ok?: Maybe<Scalars['Boolean']['output']>
  studioConfig?: Maybe<StudioConfigObjectType>
}

/**
 * EditStudioConfigRasterization sets the noRasterize option for a StudioConfig.
 * Any config, regardless of pubished status, can be updated.
 */
export type EditStudioConfigRasterization = {
  __typename?: 'EditStudioConfigRasterization'
  ok?: Maybe<Scalars['Boolean']['output']>
  studioConfig?: Maybe<StudioConfigObjectType>
}

/**
 * EmailBatch takes in the email_type parameter to determine which email to send out to the user.
 * - code_sent / code_sent_self: sends the flowcode to the user
 * - tag_referred: sends an email with a link to get a free flowtag
 *
 * :param: data - cannot contain keys: 'event_timestamp', 'batch_id' or 'to_email'
 */
export type EmailBatch = {
  __typename?: 'EmailBatch'
  ok?: Maybe<Scalars['Boolean']['output']>
}

export enum EmailType {
  CodeSent = 'CODE_SENT',
  CodeSentSelf = 'CODE_SENT_SELF',
  CollectibleCodeRequested = 'COLLECTIBLE_CODE_REQUESTED',
  TagReferred = 'TAG_REFERRED'
}

export type EntityPermissionInputType = {
  entityId?: InputMaybe<Scalars['String']['input']>
  entityType?: InputMaybe<Scalars['Int']['input']>
  permissionName?: InputMaybe<Scalars['String']['input']>
}

/**
 * Uses the same structure as the response object from ithaca to easily deconstruct resp into gql objectTypes
 * e.x GQLObjectType(**resp_data)
 */
export type EntityPermissionObjectType = {
  __typename?: 'EntityPermissionObjectType'
  entityId?: Maybe<Scalars['String']['output']>
  entityName?: Maybe<Scalars['String']['output']>
  entityType?: Maybe<Scalars['String']['output']>
  permissionName?: Maybe<Scalars['String']['output']>
}

/**
 *
 *     Supported Ithaca asset_permissions entity types
 *
 */
export enum EntityTypes {
  Org = 'ORG',
  Role = 'ROLE',
  Team = 'TEAM',
  User = 'USER'
}

export enum ExportFormat {
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG'
}

export enum ExportMethod {
  Download = 'DOWNLOAD',
  Email = 'EMAIL',
  PrintAtHome = 'PRINT_AT_HOME',
  PrintStore = 'PRINT_STORE'
}

export type FetchIthacaPermissionsResultType = {
  __typename?: 'FetchIthacaPermissionsResultType'
  assetId?: Maybe<Scalars['UUID']['output']>
  entityPermissions?: Maybe<Array<Maybe<EntityPermissionObjectType>>>
  result?: Maybe<IthacaPermissionsResultType>
}

export type ImageDetails = {
  __typename?: 'ImageDetails'
  imageUrl: Scalars['String']['output']
  templateDetails: TemplateDetails
}

export type IthacaPermissionsResultType = {
  __typename?: 'IthacaPermissionsResultType'
  error?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

export enum Layout {
  Blank = 'BLANK',
  Predesigned = 'PREDESIGNED'
}

export type LinkDjangoType = {
  __typename?: 'LinkDjangoType'
  active: Scalars['Boolean']['output']
  flowcodeId?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  redirectType: LinkRedirectType
  redirectValue: Scalars['String']['output']
  shorturl: Scalars['String']['output']
}

export type LinkInputType = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  redirectType?: InputMaybe<RedirectType>
  redirectValue?: InputMaybe<Scalars['String']['input']>
}

/** An enumeration. */
export enum LinkRedirectType {
  /** COLLECTIBLE_FP */
  CollectibleFp = 'COLLECTIBLE_FP',
  /** EMAIL */
  Email = 'EMAIL',
  /** EVENT */
  Event = 'EVENT',
  /** FACEBOOK */
  Facebook = 'FACEBOOK',
  /** FILE */
  File = 'FILE',
  /** FLOWPAGE */
  Flowpage = 'FLOWPAGE',
  /** GOOGLE_DOC */
  GoogleDoc = 'GOOGLE_DOC',
  /** INSTAGRAM */
  Instagram = 'INSTAGRAM',
  /** LINKEDIN */
  Linkedin = 'LINKEDIN',
  /** ONE_TIME_URL */
  OneTimeUrl = 'ONE_TIME_URL',
  /** PHONE */
  Phone = 'PHONE',
  /** PRESET_FP */
  PresetFp = 'PRESET_FP',
  /** SCAN_TO_ACTIVATE */
  ScanToActivate = 'SCAN_TO_ACTIVATE',
  /** SCAN_TO_OWN */
  ScanToOwn = 'SCAN_TO_OWN',
  /** SMS */
  Sms = 'SMS',
  /** SNAPCHAT */
  Snapchat = 'SNAPCHAT',
  /** SOCIAL */
  Social = 'SOCIAL',
  /** SOCIAL_MEDIA */
  SocialMedia = 'SOCIAL_MEDIA',
  /** SPOTIFY */
  Spotify = 'SPOTIFY',
  /** TIKTOK */
  Tiktok = 'TIKTOK',
  /** TWITTER */
  Twitter = 'TWITTER',
  /** URL */
  Url = 'URL',
  /** VCARD */
  Vcard = 'VCARD',
  /** VENMO */
  Venmo = 'VENMO',
  /** WIFI */
  Wifi = 'WIFI',
  /** YOUTUBE */
  Youtube = 'YOUTUBE'
}

export type Mutation = {
  __typename?: 'Mutation'
  /**
   * ArchiveBatch is called when the user chooses to archive a code.
   * The archive_reason is set to USER_ARCHIVAL accordingly.
   */
  archiveBatch?: Maybe<ArchiveBatch>
  /**
   * AssignStudioConfig gives a user the ability to use the StudioConfig
   * i.e. used by the FE to give user access to a code design after signing up
   */
  assignStudioConfiguration?: Maybe<AssignStudioConfig>
  /** Used to insert a project in the DB to map the design huddle project to the authenticated user parsed from the JWT. */
  associateProject?: Maybe<AssociateProject>
  /**
   * BulkArchiveBatches is called when the user chooses to archive a list of codes.
   * The archive_reason is set to USER_ARCHIVAL accordingly.
   */
  bulkArchiveBatches?: Maybe<BulkArchiveBatches>
  /** BulkDeleteDirectories deletes a list of directories and all the batches within it */
  bulkDeleteDirectories?: Maybe<BulkDeleteDirectories>
  /** BulkRestoreBatches is the reverse of BulkArchiveBatches and restores a list of codes to be active again. */
  bulkRestoreBatches?: Maybe<BulkRestoreBatches>
  /** BulkUpdateBatchDirectory changes or removes the directory a list of batches are in */
  bulkUpdateBatchDirectory?: Maybe<BulkUpdateBatchDirectory>
  /** BulkUpdateDirectories moves a list of directories in and out of other directories */
  bulkUpdateDirectories?: Maybe<BulkUpdateDirectories>
  /**
   * CollectBatch is used with scan to own codes and creates a BatchOwner for a Batch
   * Switches `is_collectible` to false as scan to own codes are one-time use only.
   *
   * -   CollectBatch will grant the user access to the studio_config design if they do not have it already
   * -   Note: there is no check against ithaca, however that is not a concern since users are net-new.
   *     Worth keeping a pulse on whether or not users of STO have accounts in which the same studio_config could be
   *     assigned to a user
   * -   claimed_page_id is the page_id of the slugName that is getting claimed in the preset onboarding flow. If
   *     we aren't in the preset onboarding flow then claimed_page_id should be None
   */
  collectBatch?: Maybe<CollectBatch>
  /** CreateAssetLabels creates asset labels for the specified batch id. */
  createAssetLabels?: Maybe<CreateAssetLabels>
  /**
   * CreateBatch creates a batch, link, batch_owner, and redirect object
   * It also creates entries in the batch_partial table if partial ids are supplied
   */
  createBatch?: Maybe<CreateBatch>
  /**
   * CreateBatchDesignTemplate creates a BatchDesignTemplate object for a user and configuration
   * BatchDesignTemplate's are saved code configurations that allow users to save custom designs they have made for reuse
   */
  createBatchDesignTemplate?: Maybe<CreateBatchDesignTemplate>
  /**
   * CreateBatchRules takes in a rule and/or an interstitial and merges them into a single config that determines how the batch is handled during a redirect.
   * It updates the CoreBatchRulesHistory table with an entry for each created object.
   */
  createBatchRules?: Maybe<CreateBatchRules>
  /**
   * CreateCollectibleBatch handles creating collectible flowcodes
   * All flowcodes created through this mutation are attached to our internal api_client_id and campaign
   *
   * - In the case that a batchId is passing in, we want to use that code to build a new code for the user.
   * - This code is not a collectible code but a copy of the one that was passed in
   *
   * - In the case that sendEmail is passed in, we send a notification with the new code for the user.
   */
  createCollectibleBatch?: Maybe<CreateCollectibleBatch>
  /**
   * CreateDirectory creates a directory
   * Directories can be nested
   * if batch_ids are supplied the batches are updated to be in the directory
   */
  createDirectory?: Maybe<CreateDirectory>
  /**
   * CreateExternalDomain creates an external domain for a user/org who owns their domain and
   * brings it into the Flowcode ecosystem, and assigns it to that user/org. For example,
   * if BMW owns the domain https://bmw.com/ and wants to create redirect and/or page urls
   * using this domain, this mutation creates the domain in the Domains Service and assigns
   * the BMW org as the owner of the domain.
   */
  createExternalDomain?: Maybe<CreateExternalDomain>
  /** CreatePlacementTemplateCategory creates either a child or root (parentless) category */
  createPlacementTemplateCategory?: Maybe<CreatePlacementTemplateCategory>
  /** CreatePlacementTemplateConfig creates a placement template config with a placeholder asset file */
  createPlacementTemplateConfig?: Maybe<CreatePlacementTemplateConfig>
  /** CreatePlacementTemplateDownloadData records data for a placement template download/print event */
  createPlacementTemplateDownloadData?: Maybe<CreatePlacementTemplateDownloadData>
  /** Used to create a new project in Design Huddle */
  createProject?: Maybe<Project>
  /**
   * CreateRedirectSubdomain creates a subdomain and assigns it to the requesting user,
   * creates entries in the WhiteLabelSubdomain and WhiteLabelSubdomainOwner tables in the domains service,
   * and creates an asset permission entry in ithaca for the user and subdomain.
   */
  createRedirectSubdomain?: Maybe<CreateRedirectSubdomain>
  /**
   * CreateStudioConfig creates a StudioConfig and assigns source
   * Used for code creation and duplication
   * During custom code creation the FE will call this mutation then CreateBatch
   */
  createStudioConfig?: Maybe<CreateStudioConfig>
  /** DeleteAssetLabels deletes asset labels for the specified asset label ids. */
  deleteAssetLabels?: Maybe<DeleteAssetLabels>
  /**
   * DeleteBatchDesignTemplate deletes a BatchDesignTemplate object.
   * To be used from internal admin, and requires super admin access.
   */
  deleteBatchDesignTemplate?: Maybe<DeleteBatchDesignTemplate>
  /**
   * DeleteBatchRules takes in should_delete_rule and should_delete_interstitial and removes the corresponding objects from the config.
   * If there is no remaining config after deletion, the entry will be deleted from the db.
   * Updates the CoreBatchRulesHistory table with an entry for each deleted object.
   */
  deleteBatchRules?: Maybe<DeleteBatchRules>
  /** DeleteDirectory deletes a directory and all the batches within it */
  deleteDirectory?: Maybe<DeleteDirectory>
  /**
   * DeleteExternalDomain soft-deletes an external domain. The operation will fail if the domain
   * has active/verified subdomains associated with it, or if the domain does not exist.
   */
  deleteExternalDomain?: Maybe<DeleteExternalDomain>
  /** DeletePlacementTemplateCategory deletes a placement template */
  deletePlacementTemplateCategory?: Maybe<DeletePlacementTemplateCategory>
  /** DeletePlacementTemplateConfig deletes a PlacementTemplateConfig */
  deletePlacementTemplateConfig?: Maybe<DeletePlacementTemplateConfig>
  /** Used to delete an existing project */
  deleteProject?: Maybe<DeleteProject>
  /**
   * Given subdomainId, soft deletes the associated subdomain from the domains service db and marks
   * the WhiteLabelRedirectDomain record as inactive, and deletes any shared permissions for the subdomain.
   */
  deleteRedirectSubdomain?: Maybe<DeleteRedirectSubdomain>
  /**
   * EditBatchDesign creates a new StudioConfig and points the batch to it
   * This is used when switching to a non-premade design
   */
  editBatchDesign?: Maybe<EditBatchDesign>
  /** EditConfiguration alters the configuration column of a studio config */
  editConfiguration?: Maybe<EditConfiguration>
  /**
   * EditStudioConfigRasterization sets the noRasterize option for a StudioConfig.
   * Any config, regardless of pubished status, can be updated.
   */
  editStudioConfigRasterization?: Maybe<EditStudioConfigRasterization>
  /**
   * EmailBatch takes in the email_type parameter to determine which email to send out to the user.
   * - code_sent / code_sent_self: sends the flowcode to the user
   * - tag_referred: sends an email with a link to get a free flowtag
   *
   * :param: data - cannot contain keys: 'event_timestamp', 'batch_id' or 'to_email'
   */
  emailBatch?: Maybe<EmailBatch>
  /** When a non print store export of the project happens (i.e. download, print at home, email to self), the caller calls this endpoint to save a record of that export event. Parses user from JWT. */
  projectExport?: Maybe<CreateProjectExport>
  /**
   * PublishStudioConfig sets the published on date for a StudioConfig
   * PublishedConfigs cannot be edited
   */
  publishStudioConfiguration?: Maybe<PublishStudioConfig>
  /**
   * Given subdomainId, attempts to check if the associated subdomain has been verified in cloudflare
   * reflects any changes in verification status to the is_active field in WhiteLabelRedirectDomain.
   */
  refreshRedirectSubdomainStatus?: Maybe<RefreshRedirectSubdomainStatus>
  /** RenameAssetFile updates the name of any asset */
  renameAssetFile?: Maybe<RenameAssetFile>
  /** RestoreBatch is the reverse of archive and makes a code active again */
  restoreBatch?: Maybe<RestoreBatch>
  /**
   * RestoreExternalDomain attempts to restore a soft-deleted external domain. The operation will
   * fail if restoring the domain would result in exceeding the user/org's external domain limit,
   * or if the domain does not exist.
   */
  restoreExternalDomain?: Maybe<RestoreExternalDomain>
  /**
   * Given subdomainId, restores a soft deleted subdomain in the domains service db. Sets is_active to True
   * on the WhiteLabelRedirectDomain object if the subdomain is cobranded.
   */
  restoreRedirectSubdomain?: Maybe<RestoreRedirectSubdomain>
  /** Used to save and persist a brand kit for the authenticated user. Parses user from JWT. */
  saveBrandKit?: Maybe<SaveBrandKit>
  /** Mutation that handles the sharing of various assets. */
  shareIthacaAssets?: Maybe<ShareIthacaAssets>
  /**
   * SwitchBatchDesign changes which StudioConfig a batch points to
   * this is used when switching to a premade design i.e. BLM or Earth Day
   */
  switchBatchDesign?: Maybe<SwitchBatchDesign>
  /**
   * This mutation is a custom endpoint to service the centre_bell stadium for one of our
   * enterprise clients. This endpoint is restricted for use by our CS team and will service
   * the 2023/2024 season
   */
  toggleCanadienCodes?: Maybe<ToggleCanadiensCodes>
  /**
   * TransferBatch updates the owner of the batch to be a different user
   * Creates an entry in BatchHistory to keep a log of owners
   */
  transferBatch?: Maybe<TransferBatch>
  /** TransferDirectory updates the owner of a directory. */
  transferDirectory?: Maybe<TransferDirectory>
  /** Mutation that handles the unsharing of various assets. */
  unshareIthacaAssets?: Maybe<UnshareIthacaAssets>
  /** UnsubscribeHubspot removes a user from our hubspot mailing list by sending a request to notifications */
  unsubscribeHubspot?: Maybe<UnsubscribeHubspot>
  /** UpdateAssetTags creates an entry in the AssetFile_AssetTag for each tag supplied and the asset file */
  updateAssetTags?: Maybe<UpdateAssetTags>
  /** UpdateBatchDirectory changes or removes the directory a batch is in */
  updateBatchDirectory?: Maybe<UpdateBatchDirectory>
  /** UpdateBatchLink updates the batch and/or the batch link. */
  updateBatchLink?: Maybe<UpdateBatchLink>
  /** UpdateBatchRules takes a rule and/or an interstitial config and updates them. It updates the CoreBatchRulesHistory table with an entry for each updated object. */
  updateBatchRules?: Maybe<UpdateBatchRules>
  updateCampaignName?: Maybe<UpdateCampaignName>
  /**
   * UpdateStudioConfig updates the ithaca subscription plans, display_to_all value, users, or
   * asset_file column of an existing StudioConfig
   * Does not update the config column - the column that controls code design (see EditConfiguration)
   */
  updateConfiguration?: Maybe<UpdateStudioConfig>
  /** UpdateDirectory updates name and or parent id of a directory */
  updateDirectory?: Maybe<UpdateDirectory>
  /** UpdatePlcaementTemplateCategory updates a PlacementTemplateCategory */
  updatePlacementTemplateCategory?: Maybe<UpdatePlacementTemplateCategory>
  /**
   * UpdatePlacementTemplateConfig updates a placement template config
   * setting toggle publish to true will remove the published date if it exists or sets it to now if it does not
   */
  updatePlacementTemplateConfig?: Maybe<UpdatePlacementTemplateConfig>
  /** UpdateSendgridSubscription modifies the subscription status of the user in Sendgrid */
  updateSendgridSubscription?: Maybe<UpdateSendgridSubscription>
}

export type MutationArchiveBatchArgs = {
  archiveReason?: InputMaybe<Scalars['String']['input']>
  batchId: Scalars['ID']['input']
  deactivateRedirectService?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationAssignStudioConfigurationArgs = {
  configId: Scalars['UUID']['input']
}

export type MutationAssociateProjectArgs = {
  dhProjectId: Scalars['String']['input']
  dhUserId: Scalars['String']['input']
  projectTitle: Scalars['String']['input']
  sourceTemplateId: Scalars['UUID']['input']
}

export type MutationBulkArchiveBatchesArgs = {
  archiveReason?: InputMaybe<Scalars['String']['input']>
  batchIds: Array<InputMaybe<Scalars['ID']['input']>>
  deactivateRedirectService?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationBulkDeleteDirectoriesArgs = {
  directoryIds: Array<InputMaybe<Scalars['ID']['input']>>
}

export type MutationBulkRestoreBatchesArgs = {
  batchIds: Array<InputMaybe<Scalars['ID']['input']>>
}

export type MutationBulkUpdateBatchDirectoryArgs = {
  batchIds: Array<InputMaybe<Scalars['ID']['input']>>
  moveToDirectory?: InputMaybe<Scalars['ID']['input']>
  removeDirectory?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationBulkUpdateDirectoriesArgs = {
  directoryIds: Array<InputMaybe<Scalars['ID']['input']>>
  newParentId?: InputMaybe<Scalars['ID']['input']>
  shouldMoveToRoot?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCollectBatchArgs = {
  batchId?: InputMaybe<Scalars['ID']['input']>
  codeInput?: InputMaybe<CollectBatchCodeInputType>
  flowcodeId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationCreateAssetLabelsArgs = {
  batchId: Scalars['ID']['input']
  names: Array<InputMaybe<Scalars['String']['input']>>
}

export type MutationCreateBatchArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  anonymousSessionId?: InputMaybe<Scalars['UUID']['input']>
  assetLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  campaignName?: InputMaybe<CombinedGeneratorCampaigns>
  creationSource?: InputMaybe<CreationSource>
  isCollectible?: InputMaybe<Scalars['Boolean']['input']>
  isStaticCode?: InputMaybe<Scalars['Boolean']['input']>
  nickname?: InputMaybe<Scalars['String']['input']>
  partialIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>
  redirectDomain?: InputMaybe<Scalars['String']['input']>
  redirectType: RedirectType
  studioConfigId?: InputMaybe<Scalars['UUID']['input']>
  url: Scalars['String']['input']
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationCreateBatchDesignTemplateArgs = {
  input?: InputMaybe<BatchDesignTemplateInputType>
}

export type MutationCreateBatchRulesArgs = {
  batchId: Scalars['ID']['input']
  interstitial?: InputMaybe<Scalars['JSONString']['input']>
  rule?: InputMaybe<Scalars['JSONString']['input']>
}

export type MutationCreateCollectibleBatchArgs = {
  batchId?: InputMaybe<Scalars['ID']['input']>
  campaignName?: InputMaybe<PrebuildCollectibleCampaigns>
  nickname?: InputMaybe<Scalars['String']['input']>
  partialIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>
  sendEmail?: InputMaybe<SendCollectBatchEmailInputType>
  studioConfigId?: InputMaybe<Scalars['UUID']['input']>
}

export type MutationCreateDirectoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  parentId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationCreateExternalDomainArgs = {
  domain: Scalars['String']['input']
}

export type MutationCreatePlacementTemplateCategoryArgs = {
  name: Scalars['String']['input']
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>
  tileDisplay?: InputMaybe<TileDisplayFormat>
}

export type MutationCreatePlacementTemplateConfigArgs = {
  categoryId: Scalars['UUID']['input']
  configuration: Scalars['JSONString']['input']
  name: Scalars['String']['input']
  placeholderAssetFileId: Scalars['UUID']['input']
}

export type MutationCreatePlacementTemplateDownloadDataArgs = {
  actionType: Scalars['String']['input']
  flowcodeId: Scalars['String']['input']
  templateGenerationDetails: Scalars['String']['input']
  templateId: Scalars['ID']['input']
}

export type MutationCreateProjectArgs = {
  customizations?: InputMaybe<Scalars['JSONString']['input']>
  dhUserId: Scalars['String']['input']
  projectTitle: Scalars['String']['input']
  sourceTemplateId: Scalars['UUID']['input']
}

export type MutationCreateRedirectSubdomainArgs = {
  rootDomainId: Scalars['String']['input']
  subdomain: Scalars['String']['input']
}

export type MutationCreateStudioConfigArgs = {
  configuration?: InputMaybe<Scalars['JSONString']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<SourceType>
}

export type MutationDeleteAssetLabelsArgs = {
  assetLabelIds: Array<InputMaybe<Scalars['UUID']['input']>>
}

export type MutationDeleteBatchDesignTemplateArgs = {
  templateId: Scalars['ID']['input']
}

export type MutationDeleteBatchRulesArgs = {
  ruleId: Scalars['ID']['input']
  shouldDeleteInterstitial?: InputMaybe<Scalars['Boolean']['input']>
  shouldDeleteRule?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationDeleteDirectoryArgs = {
  directoryId: Scalars['ID']['input']
}

export type MutationDeleteExternalDomainArgs = {
  domainId: Scalars['String']['input']
}

export type MutationDeletePlacementTemplateCategoryArgs = {
  placementTemplateCategoryId: Scalars['UUID']['input']
}

export type MutationDeletePlacementTemplateConfigArgs = {
  placementTemplateConfigId: Scalars['UUID']['input']
}

export type MutationDeleteProjectArgs = {
  dhProjectId: Scalars['String']['input']
}

export type MutationDeleteRedirectSubdomainArgs = {
  subdomainId: Scalars['String']['input']
}

export type MutationEditBatchDesignArgs = {
  id: Scalars['String']['input']
  isAutoDesign?: InputMaybe<Scalars['Boolean']['input']>
  newConfig: Scalars['JSONString']['input']
  partialIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>
}

export type MutationEditConfigurationArgs = {
  configId: Scalars['UUID']['input']
  configuration: Scalars['JSONString']['input']
}

export type MutationEditStudioConfigRasterizationArgs = {
  configId?: InputMaybe<Scalars['UUID']['input']>
  rasterize?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationEmailBatchArgs = {
  batchId?: InputMaybe<Scalars['ID']['input']>
  data?: InputMaybe<Scalars['JSONString']['input']>
  emailType?: InputMaybe<EmailType>
  toEmail: Scalars['String']['input']
}

export type MutationProjectExportArgs = {
  dhProjectData?: InputMaybe<Scalars['JSONString']['input']>
  dhProjectId: Scalars['String']['input']
  exportMethod: ExportMethod
  flowcodeId: Scalars['String']['input']
}

export type MutationPublishStudioConfigurationArgs = {
  configId?: InputMaybe<Scalars['UUID']['input']>
}

export type MutationRefreshRedirectSubdomainStatusArgs = {
  subdomainId: Scalars['String']['input']
}

export type MutationRenameAssetFileArgs = {
  assetFileId: Scalars['UUID']['input']
  name: Scalars['String']['input']
}

export type MutationRestoreBatchArgs = {
  batchId: Scalars['ID']['input']
}

export type MutationRestoreExternalDomainArgs = {
  domainId: Scalars['String']['input']
}

export type MutationRestoreRedirectSubdomainArgs = {
  subdomainId: Scalars['String']['input']
}

export type MutationSaveBrandKitArgs = {
  brandKitInput: BrandKitInput
}

export type MutationShareIthacaAssetsArgs = {
  assetIds: Array<InputMaybe<Scalars['UUID']['input']>>
  assetType: Scalars['String']['input']
  entityPermissions: Array<InputMaybe<EntityPermissionInputType>>
}

export type MutationSwitchBatchDesignArgs = {
  id: Scalars['String']['input']
  newConfigId: Scalars['String']['input']
  partialIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>
}

export type MutationToggleCanadienCodesArgs = {
  mode: CanadiensMode
}

export type MutationTransferBatchArgs = {
  batchId: Scalars['ID']['input']
  newOwnerEmail: Scalars['String']['input']
}

export type MutationTransferDirectoryArgs = {
  directoryId: Scalars['ID']['input']
  newOwnerEmail: Scalars['String']['input']
}

export type MutationUnshareIthacaAssetsArgs = {
  assetIds: Array<InputMaybe<Scalars['UUID']['input']>>
  assetType: Scalars['String']['input']
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>
}

export type MutationUnsubscribeHubspotArgs = {
  email: Scalars['String']['input']
}

export type MutationUpdateAssetTagsArgs = {
  assetFileId?: InputMaybe<Scalars['UUID']['input']>
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type MutationUpdateBatchDirectoryArgs = {
  batchId: Scalars['ID']['input']
  moveToDirectory?: InputMaybe<Scalars['ID']['input']>
  removeDirectory?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationUpdateBatchLinkArgs = {
  batchId: Scalars['ID']['input']
  batchInput?: InputMaybe<BatchInputType>
  linkInput?: InputMaybe<LinkInputType>
}

export type MutationUpdateBatchRulesArgs = {
  batchId: Scalars['ID']['input']
  interstitial?: InputMaybe<Scalars['JSONString']['input']>
  rule?: InputMaybe<Scalars['JSONString']['input']>
}

export type MutationUpdateCampaignNameArgs = {
  campaignId: Scalars['ID']['input']
  newName: Scalars['String']['input']
}

export type MutationUpdateConfigurationArgs = {
  args?: InputMaybe<StudioConfigInputType>
}

export type MutationUpdateDirectoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  directoryId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  parentId?: InputMaybe<Scalars['ID']['input']>
  shouldMoveToRoot?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationUpdatePlacementTemplateCategoryArgs = {
  name?: InputMaybe<Scalars['String']['input']>
  parentCategoryId?: InputMaybe<Scalars['UUID']['input']>
  placementTemplateCategoryId: Scalars['UUID']['input']
  setParentNull?: InputMaybe<Scalars['Boolean']['input']>
  tileDisplay?: InputMaybe<TileDisplayFormat>
}

export type MutationUpdatePlacementTemplateConfigArgs = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>
  configuration?: InputMaybe<Scalars['JSONString']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  placeholderAssetFileId?: InputMaybe<Scalars['UUID']['input']>
  placementTemplateConfigId: Scalars['UUID']['input']
  togglePublish?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationUpdateSendgridSubscriptionArgs = {
  email: Scalars['String']['input']
  shouldUnsubscribe?: InputMaybe<Scalars['Boolean']['input']>
}

export type NestedDirectoriesDetailType = {
  __typename?: 'NestedDirectoriesDetailType'
  nestedDirs?: Maybe<Array<Maybe<NestedDirectoryDetailType>>>
}

export type NestedDirectoryDetailType = {
  __typename?: 'NestedDirectoryDetailType'
  children?: Maybe<Array<Maybe<DirectoryDetailType>>>
  id?: Maybe<Scalars['Int']['output']>
  isRoot?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
}

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output']
}

export type NotificationSubscriptionStatuses = {
  __typename?: 'NotificationSubscriptionStatuses'
  hubspot?: Maybe<Scalars['Boolean']['output']>
  sendgrid?: Maybe<Scalars['Boolean']['output']>
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor: Scalars['String']['output']
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor: Scalars['String']['output']
}

export enum PageType {
  TrashPage = 'TRASH_PAGE'
}

export type PlacementTemplateCategoryObjectType = Node & {
  __typename?: 'PlacementTemplateCategoryObjectType'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  isDigital: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  templates?: Maybe<Array<Maybe<PlacementTemplateConfigObjectType>>>
  tileDisplay: PlacementTemplateCategoryTileDisplay
  type: PlacementTemplateCategoryType
}

export type PlacementTemplateCategoryObjectTypeTemplatesArgs = {
  customizations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  isPrintable?: InputMaybe<Scalars['Boolean']['input']>
  isPurchasable?: InputMaybe<Scalars['Boolean']['input']>
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type PlacementTemplateCategoryObjectTypeConnection = {
  __typename?: 'PlacementTemplateCategoryObjectTypeConnection'
  edgeCount?: Maybe<Scalars['Int']['output']>
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlacementTemplateCategoryObjectTypeEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** A Relay edge containing a `PlacementTemplateCategoryObjectType` and its cursor. */
export type PlacementTemplateCategoryObjectTypeEdge = {
  __typename?: 'PlacementTemplateCategoryObjectTypeEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<PlacementTemplateCategoryObjectType>
}

/** An enumeration. */
export enum PlacementTemplateCategoryTileDisplay {
  /** normal */
  Normal = 'NORMAL',
  /** wide */
  Wide = 'WIDE'
}

/** An enumeration. */
export enum PlacementTemplateCategoryType {
  /** curated */
  Curated = 'CURATED',
  /** format */
  Format = 'FORMAT'
}

export type PlacementTemplateConfigObjectType = Node & {
  __typename?: 'PlacementTemplateConfigObjectType'
  category?: Maybe<PlacementTemplateCategoryObjectType>
  configuration: Scalars['JSONString']['output']
  /** The ID of the object. */
  id: Scalars['ID']['output']
  isCustomizable?: Maybe<Scalars['Boolean']['output']>
  isPrintable: Scalars['Boolean']['output']
  isPurchasable: Scalars['Boolean']['output']
  isSingleFlowcode: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  placeholderAssetFile?: Maybe<AssetFileObjectType>
  size: Scalars['String']['output']
  sizeCount?: Maybe<Scalars['Int']['output']>
}

export type PlacementTemplateConfigObjectTypeConnection = {
  __typename?: 'PlacementTemplateConfigObjectTypeConnection'
  edgeCount?: Maybe<Scalars['Int']['output']>
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlacementTemplateConfigObjectTypeEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** A Relay edge containing a `PlacementTemplateConfigObjectType` and its cursor. */
export type PlacementTemplateConfigObjectTypeEdge = {
  __typename?: 'PlacementTemplateConfigObjectTypeEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<PlacementTemplateConfigObjectType>
}

export enum PrebuildCollectibleCampaigns {
  OptiCombinedGenerator_1 = 'OPTI_COMBINED_GENERATOR_1',
  OptiCombinedGenerator_2 = 'OPTI_COMBINED_GENERATOR_2',
  OptiCombinedGenerator_3 = 'OPTI_COMBINED_GENERATOR_3',
  OptiCombinedGenerator_4 = 'OPTI_COMBINED_GENERATOR_4',
  StarterKit = 'STARTER_KIT'
}

export type PresetLinkType = {
  __typename?: 'PresetLinkType'
  redirectType?: Maybe<RedirectType>
  redirectValue?: Maybe<Scalars['String']['output']>
}

export type Project = {
  __typename?: 'Project'
  dhProjectId: Scalars['String']['output']
  dhTemplateId: Scalars['String']['output']
  projectId: Scalars['UUID']['output']
  templateId: Scalars['UUID']['output']
  title: Scalars['String']['output']
}

/**
 * PublishStudioConfig sets the published on date for a StudioConfig
 * PublishedConfigs cannot be edited
 */
export type PublishStudioConfig = {
  __typename?: 'PublishStudioConfig'
  ok?: Maybe<Scalars['Boolean']['output']>
  publishedOn?: Maybe<Scalars['DateTime']['output']>
  studioConfig?: Maybe<StudioConfigObjectType>
}

export type Query = {
  __typename?: 'Query'
  _service?: Maybe<_Service>
  allBorderDesignConfigs?: Maybe<Array<Maybe<BorderDesignObjectType>>>
  allNestedDirectories?: Maybe<NestedDirectoriesDetailType>
  assetLabels?: Maybe<AssetLabelTypeConnection>
  assignedFlowcodeTemplates?: Maybe<StudioConfigObjectTypeConnection>
  autoDesignConfigs?: Maybe<Array<Maybe<AutoDesignObjectType>>>
  autoDesignsFromBrandData?: Maybe<Array<Maybe<AutoDesignObjectType>>>
  autoDesignsFromLogo?: Maybe<Array<Maybe<AutoDesignObjectType>>>
  autoDesignsFromUrl?: Maybe<Array<Maybe<AutoDesignObjectType>>>
  batch?: Maybe<BatchDjangoType>
  batchesForSubdomains?: Maybe<Array<Maybe<BatchDjangoType>>>
  batchRules?: Maybe<RuleBasedObjectType>
  batchTemplates?: Maybe<Array<Maybe<BatchDesignTemplateObjectType>>>
  borderDesignConfigs?: Maybe<Array<Maybe<BorderDesignObjectType>>>
  campaigns?: Maybe<ApiClientCampaignTypeConnection>
  collectible?: Maybe<CollectibleResponseType>
  customAssignedCodes?: Maybe<Array<Maybe<StudioConfigObjectType>>>
  defaultFlowcodeTemplates?: Maybe<StudioConfigObjectTypeConnection>
  directories?: Maybe<DirectoryManagementType>
  directory?: Maybe<DirectoryType>
  domainManagementDetails?: Maybe<Array<Maybe<WhiteLabelDomainManagementType>>>
  flowcodeTemplates?: Maybe<Array<Maybe<StudioConfigObjectType>>>
  /** Query to fetch flowcodes that are tied to a flowpage */
  flowpageCodes?: Maybe<Array<Maybe<BatchDjangoType>>>
  /** Get brand kit for the authenticated user. Parses user from JWT. Can return empty fields if no brand kit exists. */
  getBrandKit?: Maybe<BrandKit>
  /** Get template categories. Authentication not needed. The categories are not sorted in any particular way. Use `after` and `limit` for pagination. Max limit is 1000. */
  getCategories?: Maybe<Categories>
  /** Retrieve `ImageDetails` given a `dhProjectId`. This will be used when a user wants to download or order a print of a design project. The `imageUrl` will be an S3 url that does not expire. This endpoint is implemented by polling Design Huddle, so it may take a couple seconds to return. Also returns `TemplateDetails` with `height`, `width`, `dimensionUnit`, and `templateId` for display. */
  getImageUrl?: Maybe<ImageDetails>
  /** Get template by `templateId`. Authentication not needed. */
  getTemplate?: Maybe<Template>
  /** Get templates, can optionally filter by `productId` and `categoryIds`. Authentication not needed. All layout types are included by default. Specify which layouts to return by passing `layouts` (example: `[BLANK]`). Sorted to return templates ordered by `dhTemplateId`. This is paginated. */
  getTemplates?: Maybe<Templates>
  /** Retrieve `ImageDetails` given a `dhProjectId`. This will be used when a user wants to download or order a print of a design project. The `imageUrl` will be the url directly from Design Huddle, and it will be active for the duration of the auth token that created it. This endpoint is implemented by polling Design Huddle, so it may take a couple seconds to return. Also returns `TemplateDetails` with `height`, `width`, `dimensionUnit`, and `templateId` for display. */
  getTemporaryImageUrl?: Maybe<ImageDetails>
  me?: Maybe<UserType>
  myFlowcodes?: Maybe<CodeManagementType>
  notificationSubscriptionStatuses?: Maybe<NotificationSubscriptionStatuses>
  placementTemplateCategories?: Maybe<PlacementTemplateCategoryObjectTypeConnection>
  placementTemplateConfig?: Maybe<PlacementTemplateConfigObjectType>
  placementTemplateConfigGroup?: Maybe<Array<Maybe<PlacementTemplateConfigObjectType>>>
  placementTemplateConfigs?: Maybe<PlacementTemplateConfigObjectTypeConnection>
  placementTemplateConfigsByCategoryName?: Maybe<PlacementTemplateConfigObjectTypeConnection>
  presetLink?: Maybe<PresetLinkType>
  redirectDomains?: Maybe<Array<Maybe<WhiteLabelRedirectDomainType>>>
  redirectSubdomainPermissions?: Maybe<Array<Maybe<FetchIthacaPermissionsResultType>>>
  rootCategories?: Maybe<PlacementTemplateCategoryObjectTypeConnection>
  /** protected route for studio users only */
  studio?: Maybe<StudioObjectType>
  studioConfig?: Maybe<StudioConfigObjectType>
  studioConfigEntityPermissions?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>
  subCategories?: Maybe<PlacementTemplateCategoryObjectTypeConnection>
  subscriptionDetails?: Maybe<SubscriptionDetailType>
  subscriptionPlans?: Maybe<Array<Maybe<SubscriptionPlanType>>>
  users?: Maybe<Array<Maybe<UserType>>>
  userSavedFlowcodeTemplates?: Maybe<BatchDesignTemplateObjectTypeConnection>
  whiteLabelRedirectDomains?: Maybe<Array<Maybe<WhiteLabelRedirectDomainType>>>
}

export type QueryAssetLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  name_Icontains?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAssignedFlowcodeTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  entityTypesFilter?: InputMaybe<Array<InputMaybe<EntityTypes>>>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  includeDefaultTemplates?: InputMaybe<Scalars['Boolean']['input']>
  isCustomizable?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  name_Icontains?: InputMaybe<Scalars['String']['input']>
  name_Istartswith?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  publishedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>
  source?: InputMaybe<Scalars['String']['input']>
}

export type QueryAutoDesignConfigsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>
  ignoreColorPriority?: InputMaybe<Scalars['Boolean']['input']>
  logoFillSvgColor?: InputMaybe<Scalars['String']['input']>
  logoHeight?: InputMaybe<Scalars['Int']['input']>
  logoImageUrl?: InputMaybe<Scalars['String']['input']>
  logoWidth?: InputMaybe<Scalars['Int']['input']>
  replaceValues?: InputMaybe<Scalars['JSONString']['input']>
}

export type QueryAutoDesignsFromBrandDataArgs = {
  bottomRimText?: InputMaybe<Scalars['String']['input']>
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  count?: InputMaybe<Scalars['Int']['input']>
  logos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  topRimText?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type QueryAutoDesignsFromLogoArgs = {
  count?: Scalars['Int']['input']
  logoImageUrl: Scalars['String']['input']
}

export type QueryAutoDesignsFromUrlArgs = {
  count?: Scalars['Int']['input']
  url: Scalars['String']['input']
}

export type QueryBatchArgs = {
  batchId?: InputMaybe<Scalars['ID']['input']>
  scopePermissions?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryBatchesForSubdomainsArgs = {
  subdomainIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>
}

export type QueryBatchRulesArgs = {
  batchId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  name_Icontains?: InputMaybe<Scalars['String']['input']>
  name_Istartswith?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  prebuildOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCollectibleArgs = {
  batchId?: InputMaybe<Scalars['ID']['input']>
  flowcodeId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryDefaultFlowcodeTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  isCustomizable?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  name_Icontains?: InputMaybe<Scalars['String']['input']>
  name_Istartswith?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  publishedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>
  source?: InputMaybe<Scalars['String']['input']>
}

export type QueryDirectoriesArgs = {
  dirsNameContains?: InputMaybe<Scalars['String']['input']>
  entityId?: InputMaybe<Scalars['ID']['input']>
  entityType?: InputMaybe<Scalars['Int']['input']>
  orderDirs?: InputMaybe<Scalars['String']['input']>
  parentDirectoryId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryDirectoryArgs = {
  directoryId?: InputMaybe<Scalars['ID']['input']>
  scopePermissions?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryFlowpageCodesArgs = {
  url: Scalars['String']['input']
}

export type QueryGetCategoriesArgs = {
  after: Scalars['String']['input']
  limit: Scalars['Int']['input']
}

export type QueryGetImageUrlArgs = {
  dhProjectId: Scalars['String']['input']
  format?: InputMaybe<ExportFormat>
  projectExportId?: InputMaybe<Scalars['UUID']['input']>
}

export type QueryGetTemplateArgs = {
  templateId: Scalars['UUID']['input']
}

export type QueryGetTemplatesArgs = {
  after: Scalars['String']['input']
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>
  fetchProducts?: InputMaybe<Scalars['Boolean']['input']>
  layouts?: InputMaybe<Array<InputMaybe<Layout>>>
  limit: Scalars['Int']['input']
  productId?: InputMaybe<Scalars['UUID']['input']>
}

export type QueryGetTemporaryImageUrlArgs = {
  dhProjectId: Scalars['String']['input']
  format?: InputMaybe<ExportFormat>
}

export type QueryMyFlowcodesArgs = {
  allbatchesArchived?: InputMaybe<Scalars['Boolean']['input']>
  allbatchesExcludeCreationSource?: InputMaybe<Scalars['String']['input']>
  allbatchesNicknameContains?: InputMaybe<Scalars['String']['input']>
  directoryId?: InputMaybe<Scalars['ID']['input']>
  entityId?: InputMaybe<Scalars['ID']['input']>
  entityType?: InputMaybe<Scalars['Int']['input']>
  highlightedArchived?: InputMaybe<Scalars['Boolean']['input']>
  highlightedExcludeCreationSource?: InputMaybe<Scalars['String']['input']>
  orderBatch?: InputMaybe<Scalars['String']['input']>
  orderHighlight?: InputMaybe<Scalars['String']['input']>
  pageType?: InputMaybe<PageType>
}

export type QueryNotificationSubscriptionStatusesArgs = {
  email?: InputMaybe<Scalars['String']['input']>
}

export type QueryPlacementTemplateCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Scalars['String']['input']>
}

export type QueryPlacementTemplateConfigArgs = {
  placementTemplateConfigId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPlacementTemplateConfigGroupArgs = {
  placementTemplateConfigId?: InputMaybe<Scalars['ID']['input']>
  productId?: InputMaybe<Scalars['String']['input']>
}

export type QueryPlacementTemplateConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  categoryId?: InputMaybe<Scalars['ID']['input']>
  fetchAll?: InputMaybe<Scalars['Boolean']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
}

export type QueryPlacementTemplateConfigsByCategoryNameArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  categoryName?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
}

export type QueryPresetLinkArgs = {
  batchId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryRedirectDomainsArgs = {
  searchQuery?: InputMaybe<Scalars['String']['input']>
}

export type QueryRedirectSubdomainPermissionsArgs = {
  subdomainIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>
}

export type QueryRootCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  fetchAll?: InputMaybe<Scalars['Boolean']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type QueryStudioConfigArgs = {
  configId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryStudioConfigEntityPermissionsArgs = {
  configId?: InputMaybe<Scalars['ID']['input']>
}

export type QuerySubCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  fetchAll?: InputMaybe<Scalars['Boolean']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type QueryUsersArgs = {
  email_Startswith?: InputMaybe<Scalars['String']['input']>
}

export type QueryUserSavedFlowcodeTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
}

/** An enumeration. */
export enum RedirectType {
  CollectibleFp = 'COLLECTIBLE_FP',
  Email = 'EMAIL',
  Event = 'EVENT',
  Facebook = 'FACEBOOK',
  File = 'FILE',
  Flowpage = 'FLOWPAGE',
  GoogleDoc = 'GOOGLE_DOC',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  OneTimeUrl = 'ONE_TIME_URL',
  Phone = 'PHONE',
  PresetFp = 'PRESET_FP',
  ScanToActivate = 'SCAN_TO_ACTIVATE',
  ScanToOwn = 'SCAN_TO_OWN',
  Sms = 'SMS',
  Snapchat = 'SNAPCHAT',
  Social = 'SOCIAL',
  SocialMedia = 'SOCIAL_MEDIA',
  Spotify = 'SPOTIFY',
  Tiktok = 'TIKTOK',
  Twitter = 'TWITTER',
  Url = 'URL',
  Vcard = 'VCARD',
  Venmo = 'VENMO',
  Wifi = 'WIFI',
  Youtube = 'YOUTUBE'
}

/**
 * Given subdomainId, attempts to check if the associated subdomain has been verified in cloudflare
 * reflects any changes in verification status to the is_active field in WhiteLabelRedirectDomain.
 */
export type RefreshRedirectSubdomainStatus = {
  __typename?: 'RefreshRedirectSubdomainStatus'
  isActive?: Maybe<Scalars['Boolean']['output']>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** RenameAssetFile updates the name of any asset */
export type RenameAssetFile = {
  __typename?: 'RenameAssetFile'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** RestoreBatch is the reverse of archive and makes a code active again */
export type RestoreBatch = {
  __typename?: 'RestoreBatch'
  batch?: Maybe<BatchDjangoType>
  link?: Maybe<LinkDjangoType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * RestoreExternalDomain attempts to restore a soft-deleted external domain. The operation will
 * fail if restoring the domain would result in exceeding the user/org's external domain limit,
 * or if the domain does not exist.
 */
export type RestoreExternalDomain = {
  __typename?: 'RestoreExternalDomain'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * Given subdomainId, restores a soft deleted subdomain in the domains service db. Sets is_active to True
 * on the WhiteLabelRedirectDomain object if the subdomain is cobranded.
 */
export type RestoreRedirectSubdomain = {
  __typename?: 'RestoreRedirectSubdomain'
  ok?: Maybe<Scalars['Boolean']['output']>
}

export type RuleBasedObjectType = {
  __typename?: 'RuleBasedObjectType'
  batch: BatchDjangoType
  id: Scalars['UUID']['output']
  interstitial?: Maybe<Scalars['JSONString']['output']>
  lastModified: Scalars['DateTime']['output']
  rule?: Maybe<Scalars['JSONString']['output']>
  timeStamp: Scalars['DateTime']['output']
}

export type SaveBrandKit = {
  __typename?: 'SaveBrandKit'
  ok: Scalars['Boolean']['output']
}

export enum ScanToOwnLandingPages {
  Cpg = 'CPG',
  Designer = 'DESIGNER',
  ECommerce = 'E_COMMERCE',
  InfluencerBlack = 'INFLUENCER_BLACK',
  InfluencerPink = 'INFLUENCER_PINK',
  Restaurants = 'RESTAURANTS'
}

export type SendCollectBatchEmailInputType = {
  landingPage: ScanToOwnLandingPages
  toEmail: Scalars['String']['input']
}

/** Mutation that handles the sharing of various assets. */
export type ShareIthacaAssets = {
  __typename?: 'ShareIthacaAssets'
  assetPermissions?: Maybe<Array<Maybe<UpdateIthacaPermissionsResultType>>>
}

/** An enumeration. */
export enum SourceType {
  Autodesign = 'AUTODESIGN',
  Diy = 'DIY',
  Partial = 'PARTIAL',
  Studio = 'STUDIO'
}

export type StudioConfigInputType = {
  addUsers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  assetFile?: InputMaybe<Scalars['UUID']['input']>
  configId: Scalars['UUID']['input']
  defaultAssociatedIcon?: InputMaybe<Scalars['Boolean']['input']>
  defaultAssociatedIconName?: InputMaybe<Scalars['String']['input']>
  displayToAll?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  newIthacaPlanIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  oldIthacaPlanIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  removeUsers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type StudioConfigObjectType = Node & {
  __typename?: 'StudioConfigObjectType'
  assetFile?: Maybe<AssetFileObjectType>
  configuration: Scalars['JSONString']['output']
  creator?: Maybe<UserType>
  displayToAll: Scalars['Boolean']['output']
  entityPermissions?: Maybe<Array<Maybe<EntityPermissionObjectType>>>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  isCustomizable: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  publishedOn?: Maybe<Scalars['DateTime']['output']>
  source?: Maybe<SourceType>
  timeStamp: Scalars['DateTime']['output']
  users: Array<UserType>
}

export type StudioConfigObjectTypeEntityPermissionsArgs = {
  entityTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type StudioConfigObjectTypeConnection = {
  __typename?: 'StudioConfigObjectTypeConnection'
  edgeCount?: Maybe<Scalars['Int']['output']>
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudioConfigObjectTypeEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** A Relay edge containing a `StudioConfigObjectType` and its cursor. */
export type StudioConfigObjectTypeEdge = {
  __typename?: 'StudioConfigObjectTypeEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<StudioConfigObjectType>
}

export type StudioObjectType = {
  __typename?: 'StudioObjectType'
  assets?: Maybe<AssetFileObjectTypeConnection>
  tag?: Maybe<StudioTagObjectType>
  tags?: Maybe<Array<Maybe<StudioTagObjectType>>>
  templates?: Maybe<StudioConfigObjectTypeConnection>
}

export type StudioObjectTypeAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  assetName?: InputMaybe<Scalars['String']['input']>
  assetName_Icontains?: InputMaybe<Scalars['String']['input']>
  assetName_Istartswith?: InputMaybe<Scalars['String']['input']>
  assetType?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type StudioObjectTypeTagArgs = {
  name: Scalars['String']['input']
}

export type StudioObjectTypeTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  isCustomizable?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  name_Icontains?: InputMaybe<Scalars['String']['input']>
  name_Istartswith?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  publishedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>
  source?: InputMaybe<Scalars['String']['input']>
}

export type StudioTagObjectType = {
  __typename?: 'StudioTagObjectType'
  assetFileSet: AssetFileObjectTypeConnection
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type StudioTagObjectTypeAssetFileSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  assetName?: InputMaybe<Scalars['String']['input']>
  assetName_Icontains?: InputMaybe<Scalars['String']['input']>
  assetName_Istartswith?: InputMaybe<Scalars['String']['input']>
  assetType?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type SubscriptionDetailType = {
  __typename?: 'SubscriptionDetailType'
  companySizeOptions?: Maybe<Array<Maybe<Array<Maybe<Scalars['Int']['output']>>>>>
  industryOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  primaryFlowcodeUseOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type SubscriptionPlanType = {
  __typename?: 'SubscriptionPlanType'
  name?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

/**
 * SwitchBatchDesign changes which StudioConfig a batch points to
 * this is used when switching to a premade design i.e. BLM or Earth Day
 */
export type SwitchBatchDesign = {
  __typename?: 'SwitchBatchDesign'
  batch?: Maybe<BatchDjangoType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

export type Template = {
  __typename?: 'Template'
  dhTemplateId: Scalars['String']['output']
  dimensionUnit: Scalars['String']['output']
  height: Scalars['Float']['output']
  name: Scalars['String']['output']
  products?: Maybe<Array<TemplateProduct>>
  templateId: Scalars['UUID']['output']
  width: Scalars['Float']['output']
}

export type TemplateDetails = {
  __typename?: 'TemplateDetails'
  dimensionUnit: Scalars['String']['output']
  height: Scalars['Float']['output']
  templateId: Scalars['UUID']['output']
  width: Scalars['Float']['output']
}

export type TemplateProduct = {
  __typename?: 'TemplateProduct'
  categoryIds?: Maybe<Array<Scalars['UUID']['output']>>
  name: Scalars['String']['output']
  productId: Scalars['UUID']['output']
}

export type Templates = {
  __typename?: 'Templates'
  pageInfo: PageInfo
  templates?: Maybe<Array<Template>>
}

/** An enumeration. */
export enum TileDisplayFormat {
  Normal = 'NORMAL',
  Wide = 'WIDE'
}

/**
 * This mutation is a custom endpoint to service the centre_bell stadium for one of our
 * enterprise clients. This endpoint is restricted for use by our CS team and will service
 * the 2023/2024 season
 */
export type ToggleCanadiensCodes = {
  __typename?: 'ToggleCanadiensCodes'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * TransferBatch updates the owner of the batch to be a different user
 * Creates an entry in BatchHistory to keep a log of owners
 */
export type TransferBatch = {
  __typename?: 'TransferBatch'
  batch?: Maybe<BatchDjangoType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** TransferDirectory updates the owner of a directory. */
export type TransferDirectory = {
  __typename?: 'TransferDirectory'
  directory?: Maybe<DirectoryType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** Mutation that handles the unsharing of various assets. */
export type UnshareIthacaAssets = {
  __typename?: 'UnshareIthacaAssets'
  assetPermissions?: Maybe<Array<Maybe<UpdateIthacaPermissionsResultType>>>
}

/** UnsubscribeHubspot removes a user from our hubspot mailing list by sending a request to notifications */
export type UnsubscribeHubspot = {
  __typename?: 'UnsubscribeHubspot'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** UpdateAssetTags creates an entry in the AssetFile_AssetTag for each tag supplied and the asset file */
export type UpdateAssetTags = {
  __typename?: 'UpdateAssetTags'
  assetFile?: Maybe<AssetFileObjectType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** UpdateBatchDirectory changes or removes the directory a batch is in */
export type UpdateBatchDirectory = {
  __typename?: 'UpdateBatchDirectory'
  batch?: Maybe<BatchDjangoType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** UpdateBatchLink updates the batch and/or the batch link. */
export type UpdateBatchLink = {
  __typename?: 'UpdateBatchLink'
  batch?: Maybe<BatchDjangoType>
  link?: Maybe<LinkDjangoType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** UpdateBatchRules takes a rule and/or an interstitial config and updates them. It updates the CoreBatchRulesHistory table with an entry for each updated object. */
export type UpdateBatchRules = {
  __typename?: 'UpdateBatchRules'
  batchRule?: Maybe<RuleBasedObjectType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

export type UpdateCampaignName = {
  __typename?: 'UpdateCampaignName'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/** UpdateDirectory updates name and or parent id of a directory */
export type UpdateDirectory = {
  __typename?: 'UpdateDirectory'
  directory?: Maybe<DirectoryType>
  ok?: Maybe<Scalars['Boolean']['output']>
}

export type UpdateIthacaPermissionsResultType = {
  __typename?: 'UpdateIthacaPermissionsResultType'
  assetId?: Maybe<Scalars['UUID']['output']>
  result?: Maybe<IthacaPermissionsResultType>
}

/** UpdatePlcaementTemplateCategory updates a PlacementTemplateCategory */
export type UpdatePlacementTemplateCategory = {
  __typename?: 'UpdatePlacementTemplateCategory'
  ok?: Maybe<Scalars['Boolean']['output']>
  placementTemplateCategory?: Maybe<PlacementTemplateCategoryObjectType>
}

/**
 * UpdatePlacementTemplateConfig updates a placement template config
 * setting toggle publish to true will remove the published date if it exists or sets it to now if it does not
 */
export type UpdatePlacementTemplateConfig = {
  __typename?: 'UpdatePlacementTemplateConfig'
  ok?: Maybe<Scalars['Boolean']['output']>
  placementTemplateConfig?: Maybe<PlacementTemplateConfigObjectType>
}

/** UpdateSendgridSubscription modifies the subscription status of the user in Sendgrid */
export type UpdateSendgridSubscription = {
  __typename?: 'UpdateSendgridSubscription'
  ok?: Maybe<Scalars['Boolean']['output']>
}

/**
 * UpdateStudioConfig updates the ithaca subscription plans, display_to_all value, users, or
 * asset_file column of an existing StudioConfig
 * Does not update the config column - the column that controls code design (see EditConfiguration)
 */
export type UpdateStudioConfig = {
  __typename?: 'UpdateStudioConfig'
  ok?: Maybe<Scalars['Boolean']['output']>
  studioConfig?: Maybe<StudioConfigObjectType>
}

export type UserType = {
  __typename?: 'UserType'
  batches: Array<BatchOwnerDjangoType>
  canCreateStaticCode?: Maybe<Scalars['Boolean']['output']>
  dateJoined: Scalars['DateTime']['output']
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  flowcodeCount?: Maybe<Scalars['Int']['output']>
  flowcodes?: Maybe<BatchDjangoTypeConnection>
  flowtagCount?: Maybe<Scalars['Int']['output']>
  /** Request user's name from Ithaca service. NOTE: Careful accessing this field within query requesting multiple objects */
  fullName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isFlowArmy?: Maybe<Scalars['Boolean']['output']>
  ithacaId: Scalars['UUID']['output']
  lastName: Scalars['String']['output']
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output']
}

export type UserTypeFlowcodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  creationSource?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  nickname_Icontains?: InputMaybe<Scalars['String']['input']>
  nickname_Istartswith?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
}

export type WhiteLabelDomainManagementType = {
  __typename?: 'WhiteLabelDomainManagementType'
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  domain?: Maybe<Scalars['String']['output']>
  flowcodeSubdomains?: Maybe<Array<Maybe<WhiteLabelRedirectDomainType>>>
  flowpageSubdomains?: Maybe<Array<Maybe<WhiteLabelRedirectDomainType>>>
  id?: Maybe<Scalars['UUID']['output']>
  type?: Maybe<Scalars['Int']['output']>
}

export type WhiteLabelRedirectDomainType = {
  __typename?: 'WhiteLabelRedirectDomainType'
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  domain?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['UUID']['output']>
  isCoBranded?: Maybe<Scalars['Boolean']['output']>
  isDefault?: Maybe<Scalars['Boolean']['output']>
  isVerified?: Maybe<Scalars['Boolean']['output']>
  productType?: Maybe<Scalars['Int']['output']>
  timestamp?: Maybe<Scalars['DateTime']['output']>
}

export type FolderAncestorsFragment = {
  __typename?: 'DirectoryType'
  id: string
  name: string
  batchCount?: number | null
}

export type CustomAssignedCodesFragment = {
  __typename?: 'StudioConfigObjectType'
  id: string
  name: string
  configuration: any
  isCustomizable: boolean
  assetFile?: { __typename?: 'AssetFileObjectType'; assetName: string; url?: string | null } | null
}

export type FlowcodeTemplatesFragment = {
  __typename?: 'StudioConfigObjectType'
  id: string
  name: string
  configuration: any
  isCustomizable: boolean
  assetFile?: { __typename?: 'AssetFileObjectType'; assetName: string; url?: string | null } | null
}

export type BatchTemplatesFragment = {
  __typename?: 'BatchDesignTemplateObjectType'
  id: string
  configuration: any
  name: string
}

export type BorderDesignConfigsFragment = {
  __typename?: 'BorderDesignObjectType'
  partialId?: any | null
  studioConfig?: {
    __typename?: 'StudioConfigObjectType'
    configuration: any
    name: string
    id: string
    assetFile?: {
      __typename?: 'AssetFileObjectType'
      assetName: string
      url?: string | null
    } | null
  } | null
}

export type UpdateSendgridSubscriptionMutationVariables = Exact<{
  email: Scalars['String']['input']
  shouldUnsubscribe?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpdateSendgridSubscriptionMutation = {
  __typename?: 'Mutation'
  updateSendgridSubscription?: {
    __typename?: 'UpdateSendgridSubscription'
    ok?: boolean | null
  } | null
}

export type UnsubscribeHubspotMutationVariables = Exact<{
  email: Scalars['String']['input']
}>

export type UnsubscribeHubspotMutation = {
  __typename?: 'Mutation'
  unsubscribeHubspot?: { __typename?: 'UnsubscribeHubspot'; ok?: boolean | null } | null
}

export type CreateRedirectSubdomainMutationVariables = Exact<{
  subdomain: Scalars['String']['input']
  rootDomainId: Scalars['String']['input']
}>

export type CreateRedirectSubdomainMutation = {
  __typename?: 'Mutation'
  createRedirectSubdomain?: {
    __typename?: 'CreateRedirectSubdomain'
    ok?: boolean | null
    redirectSubdomain?: {
      __typename?: 'WhiteLabelRedirectDomainType'
      id?: any | null
      domain?: string | null
      timestamp?: any | null
      isVerified?: boolean | null
    } | null
  } | null
}

export type DeleteRedirectSubdomainMutationVariables = Exact<{
  subdomainId: Scalars['String']['input']
}>

export type DeleteRedirectSubdomainMutation = {
  __typename?: 'Mutation'
  deleteRedirectSubdomain?: { __typename?: 'DeleteRedirectSubdomain'; ok?: boolean | null } | null
}

export type RestoreRedirectSubdomainMutationVariables = Exact<{
  subdomainId: Scalars['String']['input']
}>

export type RestoreRedirectSubdomainMutation = {
  __typename?: 'Mutation'
  restoreRedirectSubdomain?: { __typename?: 'RestoreRedirectSubdomain'; ok?: boolean | null } | null
}

export type RefreshRedirectSubdomainStatusMutationVariables = Exact<{
  subdomainId: Scalars['String']['input']
}>

export type RefreshRedirectSubdomainStatusMutation = {
  __typename?: 'Mutation'
  refreshRedirectSubdomainStatus?: {
    __typename?: 'RefreshRedirectSubdomainStatus'
    isActive?: boolean | null
  } | null
}

export type CreateExternalDomainMutationVariables = Exact<{
  domain: Scalars['String']['input']
}>

export type CreateExternalDomainMutation = {
  __typename?: 'Mutation'
  createExternalDomain?: {
    __typename?: 'CreateExternalDomain'
    ok?: boolean | null
    externalDomain?: {
      __typename?: 'WhiteLabelRedirectDomainType'
      deletedAt?: any | null
      domain?: string | null
      id?: any | null
      isCoBranded?: boolean | null
      isVerified?: boolean | null
      productType?: number | null
      timestamp?: any | null
    } | null
  } | null
}

export type DeleteExternalDomainMutationVariables = Exact<{
  domainId: Scalars['String']['input']
}>

export type DeleteExternalDomainMutation = {
  __typename?: 'Mutation'
  deleteExternalDomain?: { __typename?: 'DeleteExternalDomain'; ok?: boolean | null } | null
}

export type ShareIthacaAssetsMutationVariables = Exact<{
  assetType: Scalars['String']['input']
  assetIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input']
  entityPermissions:
    | Array<InputMaybe<EntityPermissionInputType>>
    | InputMaybe<EntityPermissionInputType>
}>

export type ShareIthacaAssetsMutation = {
  __typename?: 'Mutation'
  shareIthacaAssets?: {
    __typename?: 'ShareIthacaAssets'
    assetPermissions?: Array<{
      __typename?: 'UpdateIthacaPermissionsResultType'
      assetId?: any | null
      result?: {
        __typename?: 'IthacaPermissionsResultType'
        success?: boolean | null
        error?: string | null
      } | null
    } | null> | null
  } | null
}

export type UnshareIthacaAssetsMutationVariables = Exact<{
  assetType: Scalars['String']['input']
  assetIds: Array<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>
  entityIds: Array<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>
}>

export type UnshareIthacaAssetsMutation = {
  __typename?: 'Mutation'
  unshareIthacaAssets?: {
    __typename?: 'UnshareIthacaAssets'
    assetPermissions?: Array<{
      __typename?: 'UpdateIthacaPermissionsResultType'
      assetId?: any | null
      result?: {
        __typename?: 'IthacaPermissionsResultType'
        success?: boolean | null
        error?: string | null
      } | null
    } | null> | null
  } | null
}

export type TransferDirectoryMutationVariables = Exact<{
  directoryId: Scalars['ID']['input']
  newOwnerEmail: Scalars['String']['input']
}>

export type TransferDirectoryMutation = {
  __typename?: 'Mutation'
  transferDirectory?: { __typename?: 'TransferDirectory'; ok?: boolean | null } | null
}

export type SaveCodeTemplateMutationVariables = Exact<{
  input?: InputMaybe<BatchDesignTemplateInputType>
}>

export type SaveCodeTemplateMutation = {
  __typename?: 'Mutation'
  createBatchDesignTemplate?: {
    __typename?: 'CreateBatchDesignTemplate'
    ok?: boolean | null
    batchTemplate?: {
      __typename?: 'BatchDesignTemplateObjectType'
      id: string
      name: string
    } | null
  } | null
}

export type DeleteCodeTemplateMutationVariables = Exact<{
  templateId: Scalars['ID']['input']
}>

export type DeleteCodeTemplateMutation = {
  __typename?: 'Mutation'
  deleteBatchDesignTemplate?: {
    __typename?: 'DeleteBatchDesignTemplate'
    ok?: boolean | null
  } | null
}

export type GetPresetLinkQueryVariables = Exact<{
  batchId?: InputMaybe<Scalars['ID']['input']>
}>

export type GetPresetLinkQuery = {
  __typename?: 'Query'
  presetLink?: {
    __typename?: 'PresetLinkType'
    redirectValue?: string | null
    redirectType?: RedirectType | null
  } | null
}

export type GetIsCollectibleQueryVariables = Exact<{
  flowcodeId?: InputMaybe<Scalars['ID']['input']>
  batchId?: InputMaybe<Scalars['ID']['input']>
}>

export type GetIsCollectibleQuery = {
  __typename?: 'Query'
  collectible?: {
    __typename?: 'CollectibleResponseType'
    isCollectible?: boolean | null
    redirectType?: RedirectType | null
    redirectValue?: string | null
  } | null
}

export type GetflowtagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  creationSource?: InputMaybe<Scalars['String']['input']>
}>

export type GetflowtagsQuery = {
  __typename?: 'Query'
  me?: {
    __typename?: 'UserType'
    flowcodes?: {
      __typename?: 'BatchDjangoTypeConnection'
      pageInfo: {
        __typename?: 'PageInfo'
        startCursor: string
        endCursor: string
        hasNextPage: boolean
      }
      edges: Array<{
        __typename?: 'BatchDjangoTypeEdge'
        node?: {
          __typename?: 'BatchDjangoType'
          id: string
          nickname: string
          activeLink?: {
            __typename?: 'LinkDjangoType'
            redirectValue: string
            shorturl: string
          } | null
        } | null
      } | null>
    } | null
  } | null
}

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never }>

export type GetUserInfoQuery = {
  __typename?: 'Query'
  me?: { __typename?: 'UserType'; flowtagCount?: number | null } | null
}

export type GetAssetLabelsQueryVariables = Exact<{
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  name_Icontains?: InputMaybe<Scalars['String']['input']>
}>

export type GetAssetLabelsQuery = {
  __typename?: 'Query'
  assetLabels?: {
    __typename?: 'AssetLabelTypeConnection'
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor: string }
    edges: Array<{
      __typename?: 'AssetLabelTypeEdge'
      node?: { __typename?: 'AssetLabelType'; id: string; name: string } | null
    } | null>
  } | null
}

export type GetFolderAncestorsQueryVariables = Exact<{
  directoryId: Scalars['ID']['input']
}>

export type GetFolderAncestorsQuery = {
  __typename?: 'Query'
  directory?: {
    __typename?: 'DirectoryType'
    id: string
    name: string
    batchCount?: number | null
    ancestors?: Array<{
      __typename?: 'DirectoryType'
      id: string
      name: string
      batchCount?: number | null
    } | null> | null
  } | null
}

export type GetFolderChildrenQueryVariables = Exact<{
  parentDirectoryId?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
}>

export type GetFolderChildrenQuery = {
  __typename?: 'Query'
  directories?: {
    __typename?: 'DirectoryManagementType'
    allDirs?: {
      __typename?: 'DirectoryConnection'
      pageInfo: {
        __typename?: 'PageInfo'
        hasNextPage: boolean
        hasPreviousPage: boolean
        startCursor: string
        endCursor: string
      }
      edges: Array<{
        __typename?: 'DirectoryEdge'
        node?: {
          __typename?: 'DirectoryType'
          name: string
          id: string
          descendantCount?: number | null
          parent?: { __typename?: 'DirectoryType'; name: string; id: string } | null
        } | null
      } | null>
    } | null
  } | null
}

export type GetDomainManagementDetailsQueryVariables = Exact<{ [key: string]: never }>

export type GetDomainManagementDetailsQuery = {
  __typename?: 'Query'
  domainManagementDetails?: Array<{
    __typename?: 'WhiteLabelDomainManagementType'
    id?: any | null
    domain?: string | null
    type?: number | null
    deletedAt?: any | null
    flowcodeSubdomains?: Array<{
      __typename?: 'WhiteLabelRedirectDomainType'
      id?: any | null
      domain?: string | null
      timestamp?: any | null
      isVerified?: boolean | null
      deletedAt?: any | null
    } | null> | null
    flowpageSubdomains?: Array<{
      __typename?: 'WhiteLabelRedirectDomainType'
      id?: any | null
      domain?: string | null
      timestamp?: any | null
      isVerified?: boolean | null
      deletedAt?: any | null
    } | null> | null
  } | null> | null
}

export type FlowpageFlowcodeDownloadDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type FlowpageFlowcodeDownloadDetailsQuery = {
  __typename?: 'Query'
  batch?: {
    __typename?: 'BatchDjangoType'
    archived: boolean
    studioConfig?: { __typename?: 'StudioConfigObjectType'; id: string; configuration: any } | null
    activeLink?: { __typename?: 'LinkDjangoType'; shorturl: string } | null
  } | null
}

export type WhiteLabelRedirectDomainsQueryVariables = Exact<{ [key: string]: never }>

export type WhiteLabelRedirectDomainsQuery = {
  __typename?: 'Query'
  whiteLabelRedirectDomains?: Array<{
    __typename?: 'WhiteLabelRedirectDomainType'
    domain?: string | null
    id?: any | null
    isCoBranded?: boolean | null
    isDefault?: boolean | null
    timestamp?: any | null
  } | null> | null
}

export type GetRedirectSubdomainPermissionsQueryVariables = Exact<{
  subdomainIds?: InputMaybe<
    Array<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>
  >
}>

export type GetRedirectSubdomainPermissionsQuery = {
  __typename?: 'Query'
  redirectSubdomainPermissions?: Array<{
    __typename?: 'FetchIthacaPermissionsResultType'
    assetId?: any | null
    result?: {
      __typename?: 'IthacaPermissionsResultType'
      success?: boolean | null
      error?: string | null
    } | null
    entityPermissions?: Array<{
      __typename?: 'EntityPermissionObjectType'
      entityId?: string | null
      entityType?: string | null
      permissionName?: string | null
      entityName?: string | null
    } | null> | null
  } | null> | null
}

export type GetBatchesForSubdomainsQueryVariables = Exact<{
  subdomainIds?: InputMaybe<
    Array<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>
  >
}>

export type GetBatchesForSubdomainsQuery = {
  __typename?: 'Query'
  batchesForSubdomains?: Array<{ __typename?: 'BatchDjangoType'; id: string } | null> | null
}

export type FlowcodeCountQueryVariables = Exact<{ [key: string]: never }>

export type FlowcodeCountQuery = {
  __typename?: 'Query'
  me?: { __typename?: 'UserType'; flowcodeCount?: number | null } | null
}

export type PrintStoreTempPreviewImageUrlQueryVariables = Exact<{
  dhProjectId: Scalars['String']['input']
  format?: InputMaybe<ExportFormat>
}>

export type PrintStoreTempPreviewImageUrlQuery = {
  __typename?: 'Query'
  getTemporaryImageUrl?: { __typename?: 'ImageDetails'; imageUrl: string } | null
}

export type CodeManagementQueryVariables = Exact<{
  allbatchesArchived?: InputMaybe<Scalars['Boolean']['input']>
  pageType?: InputMaybe<PageType>
}>

export type CodeManagementQuery = {
  __typename?: 'Query'
  myFlowcodes?: {
    __typename?: 'CodeManagementType'
    allBatches?: { __typename?: 'BatchConnection'; totalCount?: number | null } | null
  } | null
}

export type DisplayToAllFlowcodeTemplatesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  nameIstartswith?: InputMaybe<Scalars['String']['input']>
  nameIcontains?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  publishedOnIsnull?: InputMaybe<Scalars['Boolean']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
}>

export type DisplayToAllFlowcodeTemplatesQuery = {
  __typename?: 'Query'
  defaultFlowcodeTemplates?: {
    __typename?: 'StudioConfigObjectTypeConnection'
    totalCount?: number | null
    pageInfo: {
      __typename?: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor: string
      endCursor: string
    }
    edges: Array<{
      __typename?: 'StudioConfigObjectTypeEdge'
      cursor: string
      node?: {
        __typename?: 'StudioConfigObjectType'
        id: string
        name: string
        configuration: any
        displayToAll: boolean
        isCustomizable: boolean
        source?: SourceType | null
      } | null
    } | null>
  } | null
}

export type GetAssignedFlowcodeTemplatesQueryVariables = Exact<{
  entityTypesFilter?: InputMaybe<Array<InputMaybe<EntityTypes>> | InputMaybe<EntityTypes>>
  includeDefaultTemplates?: InputMaybe<Scalars['Boolean']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  nameIstartswith?: InputMaybe<Scalars['String']['input']>
  nameIcontains?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  publishedOnIsNull?: InputMaybe<Scalars['Boolean']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  isCustomizable?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetAssignedFlowcodeTemplatesQuery = {
  __typename?: 'Query'
  assignedFlowcodeTemplates?: {
    __typename?: 'StudioConfigObjectTypeConnection'
    totalCount?: number | null
    edges: Array<{
      __typename?: 'StudioConfigObjectTypeEdge'
      cursor: string
      node?: {
        __typename?: 'StudioConfigObjectType'
        id: string
        name: string
        configuration: any
        assetFile?: { __typename?: 'AssetFileObjectType'; id: string; assetName: string } | null
      } | null
    } | null>
    pageInfo: {
      __typename?: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor: string
      endCursor: string
    }
  } | null
}

export type GetUserSavedFlowcodeTemplatesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
}>

export type GetUserSavedFlowcodeTemplatesQuery = {
  __typename?: 'Query'
  userSavedFlowcodeTemplates?: {
    __typename?: 'BatchDesignTemplateObjectTypeConnection'
    totalCount?: number | null
    edges: Array<{
      __typename?: 'BatchDesignTemplateObjectTypeEdge'
      cursor: string
      node?: {
        __typename?: 'BatchDesignTemplateObjectType'
        id: string
        name: string
        configuration: any
        timeStamp: any
      } | null
    } | null>
    pageInfo: {
      __typename?: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor: string
      endCursor: string
    }
  } | null
}

export type AllNestedDirectoriesQueryVariables = Exact<{ [key: string]: never }>

export type AllNestedDirectoriesQuery = {
  __typename?: 'Query'
  allNestedDirectories?: {
    __typename?: 'NestedDirectoriesDetailType'
    nestedDirs?: Array<{
      __typename?: 'NestedDirectoryDetailType'
      name?: string | null
      id?: number | null
      isRoot?: boolean | null
      children?: Array<{
        __typename?: 'DirectoryDetailType'
        name?: string | null
        id?: number | null
      } | null> | null
    } | null> | null
  } | null
}

export type GetFlowcodeTemplatesCountQueryVariables = Exact<{
  entityTypesFilter?: InputMaybe<Array<InputMaybe<EntityTypes>> | InputMaybe<EntityTypes>>
  includeDefaultTemplates?: InputMaybe<Scalars['Boolean']['input']>
  isCustomizable?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetFlowcodeTemplatesCountQuery = {
  __typename?: 'Query'
  userSavedFlowcodeTemplates?: {
    __typename?: 'BatchDesignTemplateObjectTypeConnection'
    totalCount?: number | null
  } | null
  assignedFlowcodeTemplates?: {
    __typename?: 'StudioConfigObjectTypeConnection'
    totalCount?: number | null
  } | null
}
